import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var BlockerGroupsInlineStyles = /*#__PURE__*/function () {
  function BlockerGroupsInlineStyles() {
    _classCallCheck(this, BlockerGroupsInlineStyles);
  }

  _createClass(BlockerGroupsInlineStyles, null, [{
    key: "cookieScroll",
    value: function cookieScroll(_ref) {
      var fontSize = _ref.design.fontSize,
          _ref$bodyDesign = _ref.bodyDesign,
          descriptionInheritFontSize = _ref$bodyDesign.descriptionInheritFontSize,
          descriptionFontSize = _ref$bodyDesign.descriptionFontSize,
          antiAdBlocker = _ref.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-cookie-scroll",
        style: {
          fontSize: descriptionInheritFontSize ? +fontSize : +descriptionFontSize,
          textAlign: "left",
          marginBottom: 10,
          maxHeight: 400,
          overflowY: "scroll",
          paddingRight: 10
        }
      };
    }
  }]);

  return BlockerGroupsInlineStyles;
}();

export { BlockerGroupsInlineStyles };